export default __webpack_public_path__ + "static/media/zoom.df8454b0.jpg";